<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M91.14 42.98V31.34C91.14 27.25 87.83 23.94 83.74 23.94H45.09C41 23.94 37.69 27.25 37.69 31.34V42.93C29.08 46.4 23 54.83 23 64.68V96.78C23 109.72 33.49 120.22 46.44 120.22H82.28C95.22 120.22 105.72 109.73 105.72 96.78V64.68C105.72 54.87 99.69 46.48 91.14 42.98Z"
    />
    <path
      d="M83.4899 19.1H72.9099C73.0999 18.38 73.2099 17.63 73.2099 16.85C73.2099 11.96 69.2499 8 64.3599 8C59.4699 8 55.5099 11.96 55.5099 16.85C55.5099 17.63 55.6199 18.38 55.8099 19.1H45.2299C38.5399 19.1 33.1099 24.53 33.1099 31.22V45.4H42.7799V34.45C42.7799 31.15 45.4599 28.47 48.7599 28.47H79.9799C83.2799 28.47 85.9599 31.15 85.9599 34.45V45.4H95.6299V31.22C95.6299 24.53 90.1999 19.1 83.5099 19.1H83.4899Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IncomeInsurance'
  }
</script>
